const getters = {
    getBirthdays: state => state.birthdays,
    getPatients: state => state.patients
}

export default getters